import { render, staticRenderFns } from "./SideNavLayout.vue?vue&type=template&id=0f2094cf&scoped=true"
import script from "./SideNavLayout.vue?vue&type=script&lang=js"
export * from "./SideNavLayout.vue?vue&type=script&lang=js"
import style0 from "./SideNavLayout.vue?vue&type=style&index=0&id=0f2094cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2094cf",
  null
  
)

export default component.exports